export const central = { label: "(41) 3523-6600", phone: "554135236600" };
export const email = "contato@fintrustsec.com.br";
export const portalUrl = "https://cliente.livework.com.vc/login";
export const mapsUrl =
  "https://www.google.com/maps/search/?api=1&query=R.+Prof.+Pedro+Viriato+Parigot+de+Souza,+3901+-+Curitiba+-+PR";

export const tel = (phone) => `tel:+${phone}`;
